import { render, staticRenderFns } from "./ProveedoresAsignados.vue?vue&type=template&id=e954c534&scoped=true&"
import script from "./ProveedoresAsignados.vue?vue&type=script&lang=js&"
export * from "./ProveedoresAsignados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e954c534",
  null
  
)

export default component.exports